import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { AppState } from 'src/app/store/app.states';
import { getAdminUserInfo } from 'src/app/store/selector/selector';

declare var bootstrap: any;
declare var $: any;  

@Component({
  selector: 'app-admin-new-level',
  templateUrl: './new-level.component.html',
  styleUrls: ['./new-level.component.scss']
})
export class NewLevelComponent implements OnInit,OnChanges {
  @Input() level:any;
  @Input() modalid:any;
  @Output() newItemEvent = new EventEmitter<string>();
  allrules = [];
  levelrule=[];
  rules=[];
  submitting=false;
  data = [{ rule: ''}]
  user:any
  Form: FormGroup = this.fb.group({
    name: ['', Validators.compose([Validators.required])],
    formrules: [null,Validators.compose([Validators.required])]
  }); 

  constructor(private fb: FormBuilder,private store: Store<AppState>, private toastrService: ToastrService, public adminApi: AdminapiService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.levelrule=[];
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 100); 
    if(this.level){
      this.levelrule = this.level.rules;
      //this.getLevelRules(this.level.id)
    }
    this.initForm()
  }

  ngOnInit()  
  {    
    setTimeout(()=>{
      this.getUserData()
      this.getRules()
    },300) 
    
  } 

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }

  getLevelRules(id){
    this.adminApi.setLoader(true)
    this.adminApi.getlevelrules(id).subscribe((data: any) => {
      this.levelrule=data.data;
      this.initForm();
      this.adminApi.setLoader(false)
      setTimeout( ()=> { 
          $('.selectpicker').selectpicker('refresh');
      }, 300); 
    },error=>{
      this.adminApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
  }

  getUserData(){
    this.adminApi.setLoader(true)
    this.store.pipe(select(getAdminUserInfo)).subscribe(data=>{
      this.user = data
      this.adminApi.setLoader(false)
    },error=>{
      this.adminApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
  }
  
  getRules(){
    this.adminApi.setLoader(true)
    this.adminApi.getRulesList().subscribe((data: any) => {
      this.allrules = data
      this.adminApi.setLoader(false)
      setTimeout( ()=> { 
          $('.selectpicker').selectpicker('refresh');
      }, 300); 
    },error=>{
      this.adminApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
  }

  initForm(){
    this.Form = this.fb.group({
      name: [this.level?.name, Validators.compose([Validators.required])],
      formrules: [this.levelrule,Validators.compose([Validators.required])]
    });
  }

  onSubmit(form: FormGroup) {
    if (form.valid && !this.submitting) {
      this.submitting = true;
      if(this.level){
        form.value.id=this.level.id
      }
      this.adminApi.addLevel(form.value).subscribe((data: any) => {
        if (data.success) {
          this.addNewItem('change')
          if(!this.level){
            form.reset();
          }
					this.toastrService.success(data.message);
          $('#'+this.modalid).modal('hide');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.submitting = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.submitting=false;
      });
    } else {
      form.markAllAsTouched();
    }
  }

  get f2(): { [key: string]: AbstractControl } {
    return this.Form.controls;
  }
  
}
